<template>
  <div>
    <generic-view
    title="Delivery Addresses (Users, and Checkin Stations)"
    entity_name="deliveryAddress"
    :headers="headers"
    :show_excel="true"
    :show_print="true"
    icon="mdi-pin-outline"
    >
    </generic-view>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import GenericView from './GenericView'

export default {
  data() {
    return  {
      headers: [
        {
          text: 'Name',
          value: 'name',
          type:'textfield'
        },
        {
            text: 'Email',
            value: 'email',
            type: 'textfield',
            hide_client:true,
        },
        {
            text: 'Password',
            value: 'password',
            type: 'textfield',
            hide_in_table:true,
            hide_client:true,
        },
        {
          text: 'QR Or Bar Code',
          value: 'qrCode',
          type:'qr_code',
          media:'qrCodeMedia',
          media_id:'qrCodeMediaId',
          media_type:5,
          hide_client:true,
        },
        {
          text: 'Location',
          value: 'location',
          type:'gmap',
          hide_in_table:true
        }
      ],
      search: '',
      currentStation: {
        name:"",
        description:"",
        coordinate:""
      },
      showEditStation: false
    }
  },
  computed: {
    ...mapState('entities',['entity','entities','loading'])
  },
  components: {
    GenericView
  },
  methods: {
    ...mapActions('entities',['getEntities','saveEntity']),
  },
  mounted() {
    this.getEntities('deliveryAddress')
  }
}
</script>